import { Injectable } from '@angular/core';

import { Sample } from '@df/samples/sample';
import { Samples } from '@df/samples/samples';

import { LocalStorageService } from '@df/browser/storage/local-storage.service';
import { ProductResource } from '@df/catalog/product/product.resource';

@Injectable({
    providedIn: 'root'
})
export class SampleFactory {
    constructor(private productResource: ProductResource, private localStorageService: LocalStorageService) {}

    create(productId: number, samples: Samples): Sample {
        return new Sample(productId, this.productResource, this.localStorageService, samples);
    }
}
